import { render, staticRenderFns } from "./smsRecord.vue?vue&type=template&id=2b7c171c&scoped=true"
import script from "./smsRecord.vue?vue&type=script&lang=js"
export * from "./smsRecord.vue?vue&type=script&lang=js"
import style0 from "./smsRecord.vue?vue&type=style&index=0&id=2b7c171c&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c171c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7c171c')) {
      api.createRecord('2b7c171c', component.options)
    } else {
      api.reload('2b7c171c', component.options)
    }
    module.hot.accept("./smsRecord.vue?vue&type=template&id=2b7c171c&scoped=true", function () {
      api.rerender('2b7c171c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/smsRecord.vue"
export default component.exports